import { Check } from "react-feather";
import { motion } from "framer-motion";
export var Circle = function (_a) {
    var _b = _a.percentage, percentage = _b === void 0 ? 0 : _b, color = _a.color;
    var r = 20;
    var circ = 2 * Math.PI * r;
    var strokePct = ((100 - percentage) * circ) / 100; // where stroke will start, e.g. from 15% to 100%.
    return (<circle r={r} cx={23} cy={23} fill="transparent" stroke={percentage == 0 ? '' : color} // remove colour as 0% sets full circumference
     strokeWidth='4px' className='transition-all' strokeDasharray={circ} strokeDashoffset={percentage ? strokePct : 0}></circle>);
};
export var ProgressCircle = function (_a) {
    var percentage = _a.percentage;
    return (<div className="relative">
      <svg width={46} height={46}>
        <g>
          <Circle color="#E7E5EB" percentage={100}/>
          <Circle color="#E24384" percentage={percentage}/>
        </g>

      </svg>

      {percentage == 100 &&
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="text-brand-02 absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
          <Check size={24}/>
        </motion.div>}
    </div>);
};
export default ProgressCircle;
